import { useTranslation } from "react-i18next";

export default function Openingstijden() {
  const { t } = useTranslation("contact");
  const rows = t("hours.rows", { returnObjects: true }) as Array<{
    day: string;
    time: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-6 md:mb-8">
          {t("hours.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed text-center mb-10 md:mb-14 max-w-[640px] mx-auto">
          {t("hours.p1")}
        </p>

        <div className="bg-white rounded-xl border border-brand-border overflow-hidden">
          {rows.map((row, i) => (
            <div
              key={i}
              className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-4 px-5 md:px-8 py-4 md:py-5 ${i !== rows.length - 1 ? "border-b border-brand-border" : ""}`}
            >
              <span className="font-geist font-semibold text-sm md:text-base text-brand-text">
                {row.day}
              </span>
              <span className="font-geist-mono font-bold text-sm md:text-base text-brand-text">
                {row.time}
              </span>
            </div>
          ))}
        </div>

        <p className="font-geist text-sm md:text-base text-brand-text/60 mt-5 md:mt-6 text-center">
          {t("hours.note")}
        </p>
      </div>
    </section>
  );
}